require('./brokerTransferPensionPlansInternal.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardError = require('components/commons/wizardError/wizardError');
const OKModal = require('components/commons/OKModal/OKModal');

//@helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @Components
const BrokerTransferPensionPlansInternalStep1 = require('./brokerTransferPensionPlansInternalStep1/brokerTransferPensionPlansInternalStep1');
const BrokerTransferPensionPlansInternalStep2 = require('./brokerTransferPensionPlansInternalStep2/brokerTransferPensionPlansInternalStep2');
const BrokerTransferPensionPlansInternalStep3 = require('./brokerTransferPensionPlansInternalStep3/brokerTransferPensionPlansInternalStep3');
const BrokerTransferPensionPlansInternalStep4 = require('./brokerTransferPensionPlansInternalStep4/brokerTransferPensionPlansInternalStep4');
const BrokerTransferPensionPlansInternalSuccess = require('./brokerTransferPensionPlansInternalSuccess/brokerTransferPensionPlansInternalSuccess')
const BrokerInvestmentSpecialistModal = require('components/broker/brokerInvestmentSpecialistModal/brokerInvestmentSpecialistModal');
//@ utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
// @Constants
const {
    BROKER_TRANSFER_PENSION_PLAN_STEP_1,
    BROKER_TRANSFER_PENSION_PLAN_STEP_2,
    BROKER_TRANSFER_PENSION_PLAN_STEP_3,
    BROKER_TRANSFER_PENSION_PLAN_STEP_4,
    BROKER_CALLMEBACK_VALID_TEL_CODE_REG_EX,
    PHONE_AND_MOBILE_NUMBER_REGEX
} = require('constants/index');

class BrokerTransferPensionPlansInternal extends React.Component {
    constructor(props){
        super(props)
        const telephone = PersonalDataHelper.getPhoneOnly(props.immProfile);
        const telCode = PersonalDataHelper.getPhoneCodeOnly(props.immProfile);
        this.state = {
            showModal: false,
            showErrorMessagesModal: false,
            telephone,
            telCode,
            callTime: '',
            telephoneError: false,
            telephoneCodeError: false
        }
        this.validateFields = this.validateFields.bind(this);
        this.onTelCodeChange = this.onTelCodeChange.bind(this);
        this.onTelChange = this.onTelChange.bind(this);
        this.handleErrorClick = this.handleErrorClick.bind(this);
        this.handleRequestCall = this.handleRequestCall.bind(this);
        this.handleContactModalToggle = this.handleContactModalToggle.bind(this);
    }

    componentDidMount() {
        this.props.onReset();
        this.props.getSpecialists();
    }

    handleContactModalToggle(){
        this.setState({showModal:false});
    }

    handleRequestCall(){
        const valid = this.validateFields();

        if (valid) {
            this.props.onRequestCall();
            this.handleContactModalToggle();
            this.setState({
                showErrorMessagesModal: false
            });
        } else {
            this.setState({
                showErrorMessagesModal: true
            });
        }
    }

    onTelChange(value) {
        this.setState({telephone: value});
        this.props.onTelChange(value);
    }

    onTelCodeChange(value) {
        this.setState({telCode: value});
        this.props.onTelCodeChange(value);
    }

    validateFields() {
        const { telephone, telCode } = this.state;
        const profileTelephone = PersonalDataHelper.getPhoneOnly(this.props.immProfile);
        const phoneDirty = !(profileTelephone === telephone);
        const validTelCode = BROKER_CALLMEBACK_VALID_TEL_CODE_REG_EX.test(telCode);
        let validTelNumber = telephone && telephone.length;
        const countryCode = PersonalDataHelper.getPhoneCodeFromOriginCountry(this.props.immProfile.get('originCountry'))
        if (validTelNumber && telCode === `+${countryCode}` && phoneDirty) {
             validTelNumber = PHONE_AND_MOBILE_NUMBER_REGEX.test(telephone);
        }

        this.setState({telephoneError: !validTelNumber, telephoneCodeError: !validTelCode});

        return validTelNumber && validTelCode;
    }

    buildWizard() {
        const { 
            immPlans,
            immAccounts,
            immBrokerTransferPensionPlansInternal,
            immProfile,
            handleAmountChange,
            handleChangeDestinationOption,
            handleChangeTransferTypeOption,
            handleChangeFiscalizationOption,
            handleDestinationPlanChange,
            handleFilterDestinationPlans,
            handleOriginPlanChange,
            handleAccountChange,
            onCancel,
            onFinish,
            setAmountRange,
            setVisibleStep,
            setWillCancel,
            toggleDisclaimer,
            validateStep,
            handleInputSearchPlanSelected
        } = this.props;
        const wizardClass = 'broker-transfer-pension-plans-internal__wizard';
        const immSteps = immBrokerTransferPensionPlansInternal.get('steps');
        const visibleStep = immBrokerTransferPensionPlansInternal.get('visibleStep');
        const stepsAmount=immBrokerTransferPensionPlansInternal.get('steps').size;
        const immFinalButton = "brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_step4Traspass"
        const immStep1 = immBrokerTransferPensionPlansInternal.get('steps')
            .get(BROKER_TRANSFER_PENSION_PLAN_STEP_1);
        const immStep2 = immBrokerTransferPensionPlansInternal.get('steps')
            .get(BROKER_TRANSFER_PENSION_PLAN_STEP_2);
        const immStep3 = immBrokerTransferPensionPlansInternal.get('steps')
            .get(BROKER_TRANSFER_PENSION_PLAN_STEP_3);
        const immStep4 = immBrokerTransferPensionPlansInternal.get('steps')
            .get(BROKER_TRANSFER_PENSION_PLAN_STEP_4);
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            cancel: onCancel,
            finish: onFinish
        };

        return (
            <div className="broker-transfer-pension-plans-internal__wizard">
                <Wizard
                    wizardClass={wizardClass}
                    actions={actions}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                    immSteps={immSteps}
                >
                    <WizardStep
                        position="first"
                        cancelButton={true}
                        nextButton={true}
                        nextButtonDisabled={!immStep1.get('success')}
                        isLoading={immStep1.get('isFetching')}
                    >
                        <BrokerTransferPensionPlansInternalStep1
                            immStep={immStep1} 
                            immPlans={immPlans}
                            onSelectPlan={handleOriginPlanChange}/>
                    </WizardStep>
                    <WizardStep
                        position="middle"
                        cancelButton={true}
                        nextButton={true}
                        nextButtonDisabled={!immStep2.get('success')}
                        isLoading={immStep2.get('isFetching')}
                    >
                        <BrokerTransferPensionPlansInternalStep2
                            immStep1={immStep1}
                            immStep={immStep2}
                            immPlans={immPlans} 
                            immAccounts={immAccounts}
                            onSelectPlan={handleDestinationPlanChange}
                            onAccountChange={handleAccountChange}
                            onChangeDestinationOption={handleChangeDestinationOption}
                            handleFilterDestinationPlans={handleFilterDestinationPlans}
                            handlePlanSelectFromSearch={handleInputSearchPlanSelected}/>
                    </WizardStep>
                    <WizardStep
                        position="middle"
                        cancelButton={true}
                        nextButton={true}
                    >
                        <BrokerTransferPensionPlansInternalStep3 
                            immStep={immStep3}
                            handleAmountChange={handleAmountChange}
                            handleChangeTransferTypeOption={handleChangeTransferTypeOption}
                            handleChangeFiscalizationOption={handleChangeFiscalizationOption}
                            setAmountRange={setAmountRange}/>
                    </WizardStep>
                    <WizardStep
                        addLoadingBehaviour={true}
                        position="last"
                        cancelButton={true}
                        finishButton={true}
                        immFinalButton={immFinalButton}
                        finalButtonDisabled={!immStep4.get('valid')}
                    >
                        <BrokerTransferPensionPlansInternalStep4 
                            immProfile={immProfile}
                            immStep1={immStep1}
                            immStep2={immStep2}
                            immStep3={immStep3}
                            immStep4={immStep4}
                            toggleDisclaimer={toggleDisclaimer}/>
                    </WizardStep>
                </Wizard>
            </div>
        )
    }

    buildSuccess() {
        const { immBrokerTransferPensionPlansInternal } = this.props;

        return (
            <div className="broker-transfer-pension-plans-internal__success">
                <BrokerTransferPensionPlansInternalSuccess 
                    immBrokerTransferPensionPlansInternal={immBrokerTransferPensionPlansInternal}
                />
            </div>
        )
    }

    handleErrorClick(){
        this.setState({showModal:true});
     }
 
    buildError(){
        const { immInvestmentSpecialists, 
            immBrokerTransferPensionPlansInternal,
            immProfile,
            onTelCodeChange,
            onTelChange,
            onCallTimeChange,
            onCommentChange,
            onRequestBrokerCallTimeOptions,
            onSetProfilePhone
        } = this.props;
        const {showModal} = this.state;
        const errorTitle = <FormattedText value="broker-errorTitle"/>;
        const errorMessage = <FormattedText value={immBrokerTransferPensionPlansInternal.get('errorMsg')} />
        const myWalletLink = `/myprofile/broker`;
        const mainButton = {
            label: <FormattedText value="broker-broker_contact" />,
        }
        const secondaryButton = {
            label: <FormattedText value="broker-backToMyWallet" />,
            url: myWalletLink
        }

        const contentModal = (
            <BrokerInvestmentSpecialistModal
                immInvestmentSpecialists={immInvestmentSpecialists}
                immProfile={immProfile}
                onTelCodeChange={onTelCodeChange}
                onTelChange={onTelChange}
                onCallTimeChange={onCallTimeChange}
                onCommentChange={onCommentChange}
                onCloseClick={this.handleContactModalToggle}
                onRequestCall={this.handleRequestCall}
                onRequestBrokerCallTimeOptions={onRequestBrokerCallTimeOptions}
                onSetProfilePhone={onSetProfilePhone}
                showErrorMessages={this.state.showErrorMessagesModal}
            />
        );

        return (
            <div className="broker-transfer-pension-plans-external__error">
                <WizardError
                    errorMessage={errorTitle}
                    mainButton={mainButton}
                    onMainButtonClick={this.handleErrorClick}
                    secondaryButton={secondaryButton}
                >
                    <OKModal
                        extraClass="broker-transfer-pension-plans-external"
                        content={contentModal}
                        footerType="navigation"
                        isOpen={showModal}
                        onCloseCallback={this.handleContactModalToggle}
                        onPrimaryButtonClick={this.handleRequestCall}
                        onSecondaryButtonClick={this.handleContactModalToggle}
                        primaryButtonText="brokerInvestmentSpecialistModal-request"
                        primaryButtonLoading={immInvestmentSpecialists.get('requestingCall')}
                        secondaryButtonText="brokerInvestmentSpecialistModal-cancel"
                    />
                    <div>
                        <div className="broker-errors-view__primary-message">
                            {errorMessage}
                        </div>
                        <div>
                            <FormattedText
                                value="broker-errorSecondaryMessage"
                                injectedStrings={[formatText('emails-investments')]}
                            />
                        </div>
                    </div>
                </WizardError>
            </div>
        );
    }

    buildBody() {
        const { immBrokerTransferPensionPlansInternal, brokerError } = this.props;
        let content;
        const immStep4 = immBrokerTransferPensionPlansInternal.get('steps').get(BROKER_TRANSFER_PENSION_PLAN_STEP_4);
        
        if (immBrokerTransferPensionPlansInternal.get('error') || brokerError) {
            content = this.buildError();
        }
        else {
            if(immStep4.get('success') && immBrokerTransferPensionPlansInternal.get('submitSuccessful')) {
                content = this.buildSuccess();
            } else {
                content = this.buildWizard();
            }
        }
    
        return content;
    }

    render() {
        

        return (
            <div>
                {this.buildBody()}
            </div>
        );
    }
}

BrokerTransferPensionPlansInternal.propTypes = {
    brokerError: PropTypes.bool.isRequired,
    getSpecialists: PropTypes.func.isRequired,
    handleAmountChange: PropTypes.func.isRequired,
    handleFilterDestinationPlans: PropTypes.func.isRequired,
    handleChangeTransferTypeOption: PropTypes.func.isRequired,
    handleChangeFiscalizationOption: PropTypes.func.isRequired,
    handleChangeDestinationOption: PropTypes.func.isRequired,
    handleDestinationPlanChange: PropTypes.func.isRequired,
    handleOriginPlanChange: PropTypes.func.isRequired,
    handleAccountChange: PropTypes.func.isRequired,
    immPlans: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerTransferPensionPlansInternal: PropTypes.object.isRequired,
    immInvestmentSpecialists: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object,
    onCancel: PropTypes.func.isRequired,
    onCallTimeChange: PropTypes.func.isRequired,
    onCommentChange: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onRequestCall: PropTypes.func.isRequired,
    onRequestBrokerCallTimeOptions: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onTelCodeChange: PropTypes.func.isRequired,
    onTelChange: PropTypes.func.isRequired,
    onSetProfilePhone: PropTypes.func.isRequired,
    setAmountRange: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    toggleDisclaimer: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    handleInputSearchPlanSelected: PropTypes.func.isRequired
};
 
module.exports = BrokerTransferPensionPlansInternal;

